<template lang="pug">
.target-family-detail-modal
  b-modal(v-model="_value" size="xl" @ok="ok" no-close-on-backdrop no-close-on-esc)
    template(#modal-header="{ ok }")
      .option-target-family-list-modal-header
        .d-flex.justify-content-start.align-items-center
          .d-flex.justify-content-start
            span.menu-title 宛先一覧
      button.close(type="button" @click="ok") ×

    .option-target-family-list-modal-body
      TargetFamilyDetailTable(
        v-model="_items"
        :fields="fields"
      )

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import TargetFamilyDetailTable, { TargetFamilyDetailTableField, TargetFamilyDetailTableItem } from "@/pc/containers/sendDocuments/TargetFamilyDetailTable.vue";

/**
 * ### 文書送付、確認・同意ユーザー一覧モーダル
 */
@Component({
  components: {
    TargetFamilyDetailTable
  }
})
export default class TargetFamilyDetailModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** テーブル行情報 */
  @Prop({ required: true })
  items!: Array<TargetFamilyDetailTableItem>;

  /** テーブル列情報 */
  fields: Array<TargetFamilyDetailTableField> = [];

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _items(): Array<TargetFamilyDetailTableItem> {
    return this.items;
  }

  set _items(newValue: Array<TargetFamilyDetailTableItem>) {
    this.$emit("update:items", newValue);
    return;
  }

  /**
   * ### vue lifesycle mounted
   */
  public mounted(): void {
    let fields: Array<TargetFamilyDetailTableField> = this.createFields();
    this.fields = fields;

    return;
  }

  /**
   * ### 列名を作成する
   */
  public createFields(): Array<TargetFamilyDetailTableField> {
    let fields: Array<TargetFamilyDetailTableField> = [];

    fields.push({ key: "groupName", label: "利用者グループ", sortable: false, sortDirection: "desc", class: "group-name" });
    fields.push({ key: "residentName", label: "利用者名（部屋名）", sortable: false, sortDirection: "desc", class: "resident-name" });
    fields.push({ key: "familyName", label: "家族名（続柄）", sortable: false, sortDirection: "desc", class: "family-name" });
    fields.push({ key: "familyTel", label: "電話番号", sortable: false, sortDirection: "desc", class: "family-tel" });

    return fields;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }
}
</script>
